import _ from 'lodash'
import { BoardColumn, BoardContent, BoardHeader, BoardScrollWrapper } from 'views/components/Board/CardsBoard'
import { PreloadCard, PreloadCount } from 'views/components/Board/Preload'
import { formatQuantity } from 'modules/utils/numbers/formatQuantity'
import { NoDataCard } from 'views/components/Board/NoDataCard'
import { KeyValue } from 'views/components/KeyValue/KeyValue'
import { AntSkeleton, Progress, Text } from '@agro-club/agroclub-shared'
import { Count } from 'views/components/Board/styled'
import { useTranslation } from 'react-i18next'
import { ContractCard } from './ContractCard'
import { FC, memo } from 'react'
import { UsContract } from 'modules/domain/usContracts/types'

type Props = {
  onCardClick: (contract: UsContract) => void
  selectedContractId?: number
  data?: UsContract[]
  progress: Progress
  total?: number
  totalProgress?: Progress
  borderRadius?: string
  topMargin: number
  isBest?: boolean
  title: string
  isClosed?: boolean
}

const PreloadMargin: FC = () => <AntSkeleton.Button active size="small" style={{ height: 20, width: 200 }} />

export const Column: FC<Props> = memo(
  ({
    data,
    progress,
    selectedContractId,
    total,
    totalProgress,
    onCardClick,
    borderRadius,
    topMargin,
    title,
    isClosed,
  }) => {
    const { t } = useTranslation('usContracts')

    let totalBlock
    if (isClosed) {
      totalBlock = null
    } else if (totalProgress === Progress.WORK) {
      totalBlock = <PreloadMargin />
    } else {
      totalBlock = (
        <KeyValue
          horizontal
          columnGap="small"
          label={t('common:quantity')}
          labelTypo="bodyMedium"
          valueTypo="bodyMedium"
        >
          {formatQuantity(total ?? 0)}
        </KeyValue>
      )
    }

    return (
      <BoardColumn borderRadius={borderRadius}>
        <BoardHeader>
          <Text as="span" typography="titleH4">
            {title}
            {progress === Progress.WORK ? (
              <PreloadCount />
            ) : (
              <Count color={data?.length ? 'orange' : 'grey'}>{data?.length}</Count>
            )}
          </Text>
          {totalBlock}
        </BoardHeader>

        <BoardScrollWrapper topMargin={topMargin}>
          <BoardContent>
            {progress === Progress.WORK ? (
              <PreloadCard />
            ) : data?.length ? (
              data.map((item) => (
                <ContractCard
                  key={item.id}
                  contract={item}
                  onClick={onCardClick}
                  isSelected={item.id === selectedContractId}
                />
              ))
            ) : (
              <NoDataCard />
            )}
          </BoardContent>
        </BoardScrollWrapper>
      </BoardColumn>
    )
  },
)
